import { ResponsiveString } from "../typings";

export const breakpoints = ['mobile', 'tablet-portrait', 'tablet-landscape', 'tablet-pro', 'desktop-large', 'desktop-wide'];
export const breakpointLabels = ['Mobile', 'Tablet (Portrait)', 'Tablet (Landscape)', 'iPad Pro', 'Desktop Large', 'Desktop Wide'];
export const breakpointValues = [0,768,1024,1366,1440,1920];
declare global {
  interface Window {
    $contentBlocks?: any;
  }
}
export function getBreakpointValues() {
  if (!window.$contentBlocks) window.$contentBlocks = {};
  if (!window.$contentBlocks.breakpointValues) {
    window.$contentBlocks.breakpointValues = breakpointValues;
  }
  return window.$contentBlocks.breakpointValues;
}

// Fills in default value if none exists for a breakpoint
export function generateResponsiveValues(responsiveValue: string): string[] {
  if (!responsiveValue) {
    return [];
  }
  let responseArray = [];
  let splitResponsiveValues = responsiveValue.split('|');
  let lastGoodValue = splitResponsiveValues[0];
  getBreakpointValues().forEach((_value, index) => {
    let thisBreakpointValue = splitResponsiveValues[index];
    if (thisBreakpointValue) {
      lastGoodValue = thisBreakpointValue;
    }
    responseArray.push(thisBreakpointValue ? thisBreakpointValue : lastGoodValue);
  });
  return responseArray;
}

export function getCurrentBreakpointIndex(): number {
  let activeBreakpointIndex: number = 0;
  let windowWidth = window.innerWidth;
  getBreakpointValues().some(width => {
    // The first time this is true will end the loop
    let condition = width > windowWidth;
    if (!condition) {
      activeBreakpointIndex = getBreakpointValues().indexOf(width);
    }
    return condition;
  });
  return activeBreakpointIndex;
}

export function getCurrentValue(responsiveValue: string | boolean): string {
  if (!responsiveValue) {
    return '';
  }
  let currentBreakpoint = getCurrentBreakpointIndex();
  let responsiveValues = generateResponsiveValues(responsiveValue.toString());
  let returnValue: string;
  for (var i = currentBreakpoint; i >= 0; i--) {
    if (responsiveValues[i]) {
      returnValue = responsiveValues[i];
      i = -1;
    }
  }
  return returnValue;
}

/* Below Functions are Deprecated */

export function getValueAtIndex(index: number, responsiveValue: ResponsiveString): string {
  let responsiveValues = generateResponsiveValues(responsiveValue.toString());
  return responsiveValues[index].trim();
}

export function getHydratedClassString(classString: string): string {
  let cleanedString = getCurrentValue(classString).trim();
  if (cleanedString.includes('hydrated')) {
    return cleanedString.trim();
  }
  if (cleanedString) {
    return cleanedString.trim() + ' hydrated';
  }
  return 'hydrated';
}

export function objectToCssString(object: object): string {
  let string = '';
  for (var key in object) {
    if (object[key].length > 0 && !['px', '%'].includes(object[key])) {
      string += `${key}: ${object[key]};`;
    }
  }
  return string;
}
export function generateResponsiveClass(classPrefix: string, responsiveValue: string) {
  let index = -1;
  let classString = '';
  responsiveValue.split('|').forEach(value => {
    index++;
    if (!value || value === 'false') {
      return false;
    }
    classString += ` ${classPrefix}-${breakpoints[index]}-${value}`;
  });
  return classString;
}

export function insertCssIntoHead(document: Document, fontCssUrl: string) {
  let element = document.querySelector(`link[href="${fontCssUrl}"]`);
  // Only inject the element if it's not yet present
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('href', fontCssUrl);
    document.head.prepend(element);
  }
}